import angular from 'angular';

import FiltersContainerComponent from './filters-container.components';

const FiltersContainerModule = angular
    .module('control-room.commons.layout.components.filters-container', [])
    .component('crFiltersContainer', FiltersContainerComponent);

export default FiltersContainerModule;
